// BURNIQ: Verhalten auf der Seite. Rechenlogik in burniq-logic.js (getestet).
// Jeder Teil läuft für sich: Ein Fehler in einem Teil hält die anderen nicht an. Kaufkarte, Kaufleiste und Hero
// brauchen die Rechenlogik nicht und starten sofort; nur Bildfolge und Rechner warten auf deren Import.

// Merker für das Inline-Skript im Hero: Fehlt er beim Laden der Seite, ist burniq.js nicht gelaufen (Standbild statt kaltem Ofen)
document.documentElement.dataset.bqJs = '1';

const teil = (name, fn) => {
  try {
    fn();
  } catch (fehler) {
    console.error(`[burniq] ${name}:`, fehler);
  }
};
const ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;

// Kaufkarte: gewählte Stufe in Preis, Horizon-Formular, Kaufknopf, Status und Kaufleiste übernehmen.
// Die Radios selbst sind per form-Attribut ans Formular gebunden (ohne JavaScript reicht das); hier geht es um die Anzeige
// und um Horizons verstecktes Feld id, aus dem es die Warenkorb-Menge abgleicht.
teil('Kaufkarte', () => {
  document.querySelectorAll('[data-bq-kaufkarte]').forEach((karte) => {
    const wahl = karte.querySelector('[data-bq-varianten-wahl]');
    const preis = karte.querySelector('[data-bq-preis]');
    const status = karte.querySelector('[data-bq-status]');
    const leistePreis = document.querySelector('[data-bq-sticky-preis]');
    const leisteInfo = document.querySelector('[data-bq-sticky-info]');
    // Paketzeile oben im Hero (nur Produktseite, sichtbar am Handy)
    const paket = karte.closest('[data-bq-hero]')?.querySelector('[data-bq-paket]');
    const paketFeld = (name) => paket?.querySelector(`[data-bq-paket-${name}]`);
    // im Vorab-Modus gibt es kein Kaufformular: dann nur Preis und Kaufleiste
    const kaufbar = !!karte.querySelector('product-form-component');
    const uebernehmen = (radio) => {
      const lieferbar = radio.dataset.verfuegbar !== 'false';
      if (preis) preis.textContent = radio.dataset.preis;
      karte.querySelectorAll('product-form-component input[type="hidden"][name="id"]').forEach((feld) => {
        feld.value = radio.value;
      });
      if (kaufbar) {
        karte.querySelectorAll('add-to-cart-component button[name="add"]').forEach((knopf) => {
          knopf.disabled = !lieferbar;
          knopfText(knopf, lieferbar ? wahl?.dataset.textKaufen : wahl?.dataset.textAus);
        });
        // Direktkauf-Knopf (Shop Pay, PayPal …): Horizon blendet ihn per hidden aus, wenn die Startvariante nicht lieferbar ist
        karte.querySelectorAll('.accelerated-checkout-block').forEach((block) => (block.hidden = !lieferbar));
        if (status) status.hidden = lieferbar;
      }
      if (leistePreis) leistePreis.textContent = `${radio.dataset.titel} · ${radio.dataset.preis}`;
      if (leisteInfo && radio.dataset.wuerfel) {
        leisteInfo.textContent = `${radio.dataset.wuerfel} Würfel · ${radio.dataset.ct} ct je Würfel`;
        leisteInfo.hidden = false;
      }
      if (paket) {
        const felder = { titel: radio.dataset.titel, wuerfel: radio.dataset.wuerfel, preis: radio.dataset.preis, ct: radio.dataset.ct };
        Object.entries(felder).forEach(([name, wert]) => {
          const feld = paketFeld(name);
          if (feld && wert) feld.textContent = wert;
        });
      }
    };
    karte.addEventListener('change', (e) => {
      if (e.target.matches('[data-bq-varianten-wahl] input[type="radio"]')) uebernehmen(e.target);
    });
    const start = karte.querySelector('[data-bq-varianten-wahl] input:checked');
    if (start) uebernehmen(start);
  });
});

// Beschriftung von Horizons Kaufknopf tauschen: Sie ist der Textknoten neben Symbol und Häkchen-Animation
function knopfText(knopf, text) {
  if (!text) return;
  const knoten = [...knopf.childNodes].find((k) => k.nodeType === Node.TEXT_NODE && k.textContent.trim());
  if (knoten) knoten.textContent = text;
}

// Warenkorb-Netzfehler: Horizon meldet ihn nur als Ereignis (shopify:cart:error, Code SERVICE_UNAVAILABLE) und zeigt
// nichts an. Fehler des Shops (z. B. Menge nicht verfügbar) zeigt Horizon selbst am Knopf.
teil('Warenkorb-Fehler', () => {
  document.querySelectorAll('[data-bq-kaufkarte]').forEach((karte) => {
    const meldung = karte.querySelector('[data-bq-fehler]');
    const formular = karte.querySelector('product-form-component');
    if (!meldung || !formular) return;
    formular.addEventListener('shopify:cart:error', (e) => {
      if (e.code !== 'SERVICE_UNAVAILABLE') return;
      meldung.textContent =
        'Der Warenkorb ist gerade nicht erreichbar. Bitte prüfe deine Internetverbindung und versuche es noch einmal.';
      meldung.hidden = false;
    });
    // neuer Versuch: alte Meldung weg
    formular.addEventListener('submit', () => (meldung.hidden = true), true);
  });
});

// Kaufleiste: zeigen, solange weder Mengenwahl noch Kauf- bzw. Vormerkknopf im Bild sind. Am Handy liegen beide beim
// Laden unter dem ersten Bildschirm, die Leiste bringt Preis und Knopf also sofort ins Bild; am Desktop sind sie sichtbar.
teil('Kaufleiste', () => {
  const leiste = document.querySelector('[data-bq-sticky]');
  const karte = document.getElementById('bq-kaufkarte');
  const fuss = document.querySelector('footer');
  if (!leiste || !karte || !('IntersectionObserver' in window)) return;
  const kaufteile = [karte.querySelector('[data-bq-varianten-wahl]'), karte.querySelector('product-form-component, .bq-vormerken')]
    .filter(Boolean);
  if (!kaufteile.length) kaufteile.push(karte);
  // ebenso der Abschluss mit eigenem Vormerk-Formular bzw. Kaufknopf: dort braucht es die Leiste nicht doppelt
  kaufteile.push(...document.querySelectorAll('.bq-final__vormerken, .bq-final a.bq-btn-glut'));
  const link = leiste.querySelector('a');
  const sichtbar = new Map();
  const io = new IntersectionObserver((eintraege) => {
    eintraege.forEach((e) => sichtbar.set(e.target, e.isIntersecting));
    // Leiste nur, wenn kein Kaufteil im Bild ist und der Fuß mit den Rechtstexten noch nicht
    const an = !kaufteile.some((t) => sichtbar.get(t)) && !(fuss && sichtbar.get(fuss));
    leiste.classList.toggle('bq-sticky--an', an);
    if (link) link.tabIndex = an ? 0 : -1;
  });
  kaufteile.forEach((t) => io.observe(t));
  if (fuss) io.observe(fuss);
  // Verkauf: Tippen legt die gewählte Menge über Horizons Kaufknopf der Kaufkarte in den Warenkorb (öffnet die
  // Warenkorb-Schublade). Ist die Menge nicht lieferbar (Knopf gesperrt), bleibt es beim Sprung zur Kaufkarte.
  const kaufknopf = karte.querySelector('add-to-cart-component button[name="add"]');
  if (link && kaufknopf && 'bqDirekt' in leiste.dataset) {
    link.addEventListener('click', (e) => {
      if (kaufknopf.disabled) return;
      e.preventDefault();
      kaufknopf.click();
    });
  }
  // Vorab-Modus: Tippen führt direkt ins E-Mail-Feld der Kaufkarte statt nur an deren Anfang
  const feld = karte.querySelector('.bq-vormerken input[type="email"]');
  if (link && feld) {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      feld.scrollIntoView({ block: 'center', behavior: ruhig ? 'auto' : 'smooth' });
      feld.focus({ preventScroll: true });
    });
  }
});

// Galerie „In der Box“: Vorschaubild springt zum Bild, das sichtbare Bild markiert sein Vorschaubild.
// Wischen geht auch ohne JavaScript (scroll-snap); seitlich scrollen statt scrollIntoView, damit die Seite nicht springt.
teil('Galerie', () => {
  document.querySelectorAll('[data-bq-galerie]').forEach((galerie) => {
    const bahn = galerie.querySelector('.bq-galerie__bahn');
    const bilder = [...galerie.querySelectorAll('.bq-galerie__bild')];
    const knoepfe = [...galerie.querySelectorAll('[data-bq-galerie-ziel]')];
    if (!bahn || bilder.length < 2 || !knoepfe.length) return;
    const markieren = (i) =>
      knoepfe.forEach((k, j) => (j === i ? k.setAttribute('aria-current', 'true') : k.removeAttribute('aria-current')));
    knoepfe.forEach((k) =>
      k.addEventListener('click', () => {
        const i = Number(k.dataset.bqGalerieZiel);
        bahn.scrollTo({ left: bilder[i].offsetLeft - bahn.offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
        markieren(i);
      })
    );
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (eintraege) => eintraege.forEach((e) => e.isIntersecting && markieren(bilder.indexOf(e.target))),
      { root: bahn, threshold: 0.6 }
    );
    bilder.forEach((b) => io.observe(b));
  });
});

// Hero „Ofen anzünden“: kalter Ofen → Anzünd-Clip (per Klick oder nach Wartezeit) → Feuer-Schleife.
// Die Klasse bq-zuenden-bereit setzt ein Inline-Skript vor dem ersten Zeichnen (nur Desktop, Bewegung erlaubt).
// Jeder Fehler hier nimmt sie wieder weg: lieber das brennende Standbild als ein kalter Ofen, der nie angeht.
teil('Ofen anzünden', () => {
  document.querySelectorAll('[data-bq-hero].bq-zuenden-bereit').forEach((hero) => {
    try {
      ofenStarten(hero);
    } catch (fehler) {
      hero.classList.remove('bq-zuenden-bereit');
      throw fehler;
    }
  });
});

function ofenStarten(hero) {
  const knopf = hero.querySelector('[data-bq-zuenden]');
  const pause = hero.querySelector('[data-bq-pause]');
  const pauseText = pause?.querySelector('[data-bq-pause-text]');
  const clip = hero.querySelector('.bq-hero__zuenden');
  const schleife = hero.querySelector('.bq-hero__video');
  if (!knopf || !clip || !schleife) {
    hero.classList.remove('bq-zuenden-bereit');
    return;
  }
  let gestartet = false;
  let brennend = false;
  let angehalten = false;
  let imBild = true;
  clip.preload = 'auto';
  clip.load();
  // was gerade laufen soll: erst der Clip, danach die Schleife
  const aktuell = () => (brennend ? schleife : clip);
  const abspielen = () => {
    if (!gestartet || angehalten || !imBild) return;
    if (brennend) schleife.play().catch(() => {});
    // Clip geht nicht (Datei fehlt, Autoplay gesperrt): direkt zur Schleife. AbortError heißt nur „durch pause()
    // unterbrochen“ (Anhalten, Wegscrollen) und ist kein Grund, den Clip zu überspringen.
    else clip.play().catch((e) => e?.name !== 'AbortError' && brennt());
  };
  function brennt() {
    if (brennend) return;
    brennend = true;
    hero.classList.add('bq-an');
    schleife.currentTime = 0;
    abspielen();
  }
  clip.addEventListener('playing', () => hero.classList.add('bq-zuendet'), { once: true });
  clip.addEventListener('ended', brennt);
  // Netz- oder Dekodierfehler mitten im Clip: Das play()-Versprechen ist dann schon erfüllt und „ended“ kommt nie.
  // Fehler vor dem Anzünden fängt abspielen() über das abgelehnte play() ab.
  const clipFehler = () => gestartet && brennt();
  clip.addEventListener('error', clipFehler);
  clip.querySelector('source')?.addEventListener('error', clipFehler);
  schleife.addEventListener('playing', () => hero.classList.add('bq-schleife-laeuft'), { once: true });

  const anzuenden = () => {
    if (gestartet) return;
    gestartet = true;
    hero.classList.add('bq-brennt');
    schleife.preload = 'auto';
    schleife.load();
    abspielen();
    // Der Knopf blendet per CSS aus; danach raus aus der Tab-Reihenfolge, an seine Stelle tritt „Feuer anhalten“.
    // Fokus nur mitnehmen, wenn er dann noch auf dem Knopf liegt (wer inzwischen weitergetabbt ist, bleibt, wo er ist)
    setTimeout(() => {
      const fokusAufKnopf = document.activeElement === knopf;
      knopf.hidden = true;
      if (!pause) return;
      pause.hidden = false;
      if (fokusAufKnopf) pause.focus();
    }, 320);
  };
  knopf.addEventListener('click', anzuenden);

  // WCAG 2.2.2: Das Feuer läuft dauerhaft, deshalb lässt es sich anhalten
  pause?.addEventListener('click', () => {
    angehalten = !angehalten;
    pause.toggleAttribute('data-angehalten', angehalten);
    if (pauseText) pauseText.textContent = angehalten ? 'Feuer weiterlaufen lassen' : 'Feuer anhalten';
    if (angehalten) aktuell().pause();
    else abspielen();
  });

  // außerhalb des Bildes pausieren, wieder im Bild weiterlaufen (außer angehalten)
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      imBild = e.isIntersecting;
      if (imBild) abspielen();
      else if (gestartet) aktuell().pause();
    }).observe(hero);
  }
  const sekunden = Number(knopf.dataset.bqAuto || 0);
  if (sekunden > 0) setTimeout(anzuenden, sekunden * 1000);
}

// Videoschleifen: erst laden und abspielen, wenn sie ins Bild kommen; bei „Bewegung reduzieren“ nie
teil('Schleifen', () => {
  const schleifen = document.querySelectorAll('video[data-bq-loop]');
  if (!schleifen.length || ruhig || !('IntersectionObserver' in window)) return;
  const beobachter = new IntersectionObserver(
    (eintraege) => {
      eintraege.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) target.play().catch(() => {});
        else target.pause();
      });
    },
    { rootMargin: '200px 0px' }
  );
  schleifen.forEach((v) => beobachter.observe(v));
});

// Hero: Bildfolge passend zum Scrollen, solange der Hero steht
function heroStarten(hero, { fortschritt, bildFuerFortschritt }) {
  const canvas = hero.querySelector('#bq-seq');
  const inner = hero.querySelector('.bq-hero__inner');
  // nur wenn der Hero steht (CSS entscheidet nach Breite, Höhe und „Bewegung reduzieren“), sonst bleibt das Standbild
  if (!canvas || ruhig || getComputedStyle(inner).position !== 'sticky') return;
  const track = hero.querySelector('.bq-hero__track');
  const spacer = hero.querySelector('.bq-hero__spacer');
  const n = Number(canvas.dataset.anzahl);
  const basis = canvas.dataset.basis;
  const ctx = canvas.getContext('2d');
  const bilder = new Array(n);
  let aktuell = -1;
  const url = (i) => `${basis}burniq-seq-${String(i + 1).padStart(3, '0')}.webp`;
  const zeichnen = (i) => {
    // nächstes schon geladene Bild davor nehmen, nie auf das Netz warten
    let j = i;
    while (j >= 0 && !(bilder[j] && bilder[j].complete && bilder[j].naturalWidth)) j--;
    if (j < 0 || j === aktuell) return;
    aktuell = j;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bilder[j], 0, 0, canvas.width, canvas.height);
  };
  const stand = () => bildFuerFortschritt(fortschritt(track.getBoundingClientRect().top, spacer.offsetHeight), n);
  const laden = (i) => {
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => {
      if (i === 0) {
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        zeichnen(stand());
        hero.classList.add('bq-seq-bereit');
      } else if (i <= stand() && i > aktuell) {
        zeichnen(stand());
      }
    };
    img.src = url(i);
    bilder[i] = img;
  };
  laden(0);
  // Rest nachladen, wenn der Browser Zeit hat
  const rest = () => {
    for (let i = 1; i < n; i++) laden(i);
  };
  'requestIdleCallback' in window ? requestIdleCallback(rest, { timeout: 1500 }) : setTimeout(rest, 600);
  let wartet = false;
  // Horizon scrollt ab 990 px in .page-wrapper statt im Fenster; Capture auf document fängt beides
  document.addEventListener(
    'scroll',
    () => {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(() => {
        wartet = false;
        zeichnen(stand());
      });
    },
    { passive: true, capture: true }
  );
}

// Saison-Rechner: Bedarf aus den Reglern, Empfehlung = günstigste Kombination der Stufen, die den Bedarf deckt
function rechnerStarten({ bedarf, empfehlung, euro }) {
  document.querySelectorAll('[data-bq-rechner]').forEach((r) => {
    const feld = (name) => r.querySelector(`[name="${name}"]`);
    const ausgabe = r.querySelector('[data-bq-ergebnis]');
    const link = r.querySelector('[data-bq-empfehlung]');
    const empfText = r.querySelector('[data-bq-empfehlung-text]');
    const quelle = r.querySelector('[data-bq-varianten]');
    if (!quelle || !ausgabe) return;
    // im Vorab-Modus zählt jede Stufe (es wird nichts verkauft), sonst nur lieferbare
    const vorab = r.hasAttribute('data-bq-vorab');
    const stufen = JSON.parse(quelle.textContent).filter((s) => vorab || s.verfuegbar);
    const titel = new Map(stufen.map((s) => [s.id, s.titel]));
    const rechnen = () => {
      const b = bedarf({ feuerProWoche: feld('feuer').value, wuerfelProFeuer: feld('wuerfel').value, wochen: feld('wochen').value });
      r.querySelectorAll('output').forEach((o) => {
        const regler = r.querySelector('#' + o.htmlFor.value);
        if (regler) o.value = regler.value;
      });
      ausgabe.textContent = `${b.wuerfel} Würfel · ${b.boxen} ${b.boxen === 1 ? 'Box' : 'Boxen'}`;
      const e = empfehlung(b.boxen, stufen);
      if (!e) {
        if (empfText) empfText.textContent = 'Derzeit nicht lieferbar';
        if (link) link.hidden = true;
        return;
      }
      const name = e.teile.map((t) => (t.menge > 1 ? `${t.menge} × ${titel.get(t.id)}` : titel.get(t.id))).join(' + ');
      if (empfText) empfText.textContent = `Empfehlung: ${name} · ${euro(e.preis)}`;
      if (!link) return;
      link.hidden = false;
      link.textContent = `${name} in den Warenkorb`;
      link.href = '/cart/add?' + e.teile.map((t) => `items[][id]=${t.id}&items[][quantity]=${t.menge}`).join('&');
    };
    r.addEventListener('input', rechnen);
    rechnen();
  });
}

// Rechenlogik über die versionierte URL aus dem Meta-Tag laden: Shopify cacht Assets ein Jahr, ein fester Import könnte
// nach einem Update alte Logik mit neuem Verhalten mischen. Schlägt der Import fehl, bleiben Standbild und Rechner-Startwerte.
const logikUrl = document.querySelector('meta[name="bq-logik"]')?.content || './burniq-logic.js';
import(logikUrl)
  .then((logik) => {
    teil('Bildfolge', () => document.querySelectorAll('[data-bq-hero]').forEach((hero) => heroStarten(hero, logik)));
    teil('Rechner', () => rechnerStarten(logik));
  })
  .catch((fehler) => console.error('[burniq] Rechenlogik nicht geladen:', fehler));
